import React, { useContext, useEffect, useState } from 'react';
import Util from '../../../Util';
import Breadcrumb from '../../shared/Breadcrumb';
import SideNav from './SideNav';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import alertify from 'alertifyjs';
import { apiRoutes } from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';

const Profile = (props) => {
    const { userState } = useContext(AuthContext);
  
    const userType = props.location.state.userType;
    const user = props.location.state.user;
    const isDoctor = userType == 'doctor';

    const [modalShow, setModalShow] = useState(false);
 
    const [fee, setFee] = useState({consultingFee: 0, bookingFee: 0, videoCallFee: 0, doctorId: 0, discount: 0})

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    useEffect(() => {
        console.log(isDoctor);
        if(isDoctor)
        { 
            axios.get(apiRoutes.getDoctorProfile + user.doctorId, options)
            .then((response) => {
                if(response.status === 200)
                {
                    console.log(response.data.doctorVisitingFee)
                    setFee({...fee, doctorId: user.doctorId})
                    if(response.data.doctorVisitingFee != undefined && response.data.doctorVisitingFee.length > 0)
                    {
                        console.log(response.data.doctorVisitingFee[0]);
                        setFee({doctorId: response.data.doctorId, discount: response.data.doctorVisitingFee[0].discount, consultingFee: response.data.doctorVisitingFee[0].consultingFee, bookingFee: response.data.doctorVisitingFee[0].bookingFee, videoCallFee: response.data.doctorVisitingFee[0].videoCallFee});
                    }
                }
            }, (error) => {
            console.log(error);
            });
        }
    }, []);


    const handleSubmit = () => {
        axios.post(apiRoutes.UpdateFees, JSON.stringify(fee), options)
        .then((response) => {
            alertify.success(`Doctor fees updated successfully`);
            setModalShow(false);
        }, (error) => {
            console.log(error);
        });


    }

    const OpenModel = () => {
        setModalShow(true);
    }

    return (  
        <div>
            <Breadcrumb title={`${isDoctor ? 'Dr. ' : '' } ${user.firstName} ${user.lastName}`} subtitle={'Profile'} ></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='appoinments' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="profile-header">
                                        <div className="row align-items-center">
                                            <div className="col-auto profile-image">
                                                <a href="#">
                                                    <img className="rounded-circle" alt="User Image" src={Util.loadImage(user.profileImage)} />
                                                </a>
                                            </div>
                                            <div className="col ml-md-n2 profile-user-info">
                                                <h4 className="user-name mb-0">{isDoctor && 'Dr.'} {user.firstName} {user.lastName} </h4>
                                                <h6 className="text-muted">{user.emailAddress}</h6>
                                                <div className="user-Location"><i className="fa fa-map-marker"></i> {user.state}, {user.country}</div>
                                                {
                                                    isDoctor && 
                                                    <div>
                                                        <div className="about-text"> {user.subTitle}</div>
                                                        <div>{user.biography} </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="profile-menu">
                                        <ul className="nav nav-tabs nav-tabs-solid">
                                            <li className="nav-item">
                                                <a className="nav-link active" data-toggle="tab" href="#per_details_tab">About</a>
                                            </li>
                                        </ul>
                                    </div>	
                                    <div className="tab-content profile-tab-cont">
                                        <div className="tab-pane fade show active" id="per_details_tab">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <h5 className="card-title d-flex justify-content-between">
                                                                <span>Details</span> 
                                                                {
                                                                   isDoctor && <a className="edit-link" data-toggle="modal" href="#edit_personal_details" onClick={OpenModel} ><i className="fa fa-edit mr-1"></i>Edit Fee</a>
                                                                }
                                                            </h5>
                                                            <div className="row">
                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Name</p>
                                                                <p className="col-sm-10">{isDoctor && 'Dr.'} {user.firstName} {user.lastName}</p>
                                                            </div>
                                                            {
                                                                !isDoctor && <div className="row">
                                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Date of Birth</p>
                                                                                <p className="col-sm-10">{
                                                                                                            new Intl.DateTimeFormat("en-GB", {
                                                                                                            year: "numeric",
                                                                                                            month: "short",
                                                                                                            day: "2-digit"
                                                                                                            }).format(new Date(user.dob+".000Z"))
                                                                                                        }</p>
                                                                            </div>
                                                            }
                                                            
                                                            <div className="row">
                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Email ID</p>
                                                                <p className="col-sm-10">{user.emailAddress}</p>
                                                            </div>
                                                            <div className="row">
                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Mobile</p>
                                                                <p className="col-sm-10">{user.phone}</p>
                                                            </div>
                                                            {
                                                                isDoctor && <div className="row">
                                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Cousulting Fee</p>
                                                                                <p className="col-sm-10">${fee != undefined ? fee.consultingFee : 0}</p>
                                                                            </div>
                                                            }
                                                            {
                                                                isDoctor && <div className="row">
                                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Booking Fee</p>
                                                                                <p className="col-sm-10">${fee != undefined ? fee.bookingFee : 0}</p>
                                                                            </div>
                                                            }
                                                            {
                                                                isDoctor && <div className="row">
                                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Video Call Fee</p>
                                                                                <p className="col-sm-10">${fee != undefined ? fee.videoCallFee : 0}</p>
                                                                            </div>
                                                            }
                                                            {
                                                                isDoctor && <div className="row">
                                                                                <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">Discount %</p>
                                                                                <p className="col-sm-10">${fee != undefined ? fee.discount : 0}</p>
                                                                            </div>
                                                            }
                                                            <div className="row">
                                                               
                                                                <p className="col-sm-2 text-muted text-sm-right mb-0">Address</p>
                                                                {
                                                                    isDoctor && <div className="col-sm-10 mb-0">
                                                                                    <p>{user.addressLine1}<br />
                                                                                    {user.addressLine2}<br />
                                                                                    {user.city} {user.state}<br />
                                                                                    {user.country} </p>
                                                                                </div>
                                                                }
                                                                {
                                                                    !isDoctor && <div className="col-sm-10 mb-0">
                                                                                    <p >{user.address}<br />
                                                                                    {user.city} {user.state} {user.zipcode}<br />
                                                                                    {user.country} </p>
                                                                                </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <Modal show={modalShow}  onHide={() => setModalShow(false)} size="lg">
                                        <Modal.Header closeButton>
                                            <Modal.Title id="contained-modal-title-vcenter">
                                                Edit Fee Details
                                            </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="modal-body">
                                                <form onSubmit={e => {e.preventDefault(); handleSubmit();}} >
                                                    <div className="row form-row">
                                                        <div className="col-12 col-sm-12">
                                                            <div className="form-group">
                                                                <label>Cousulting Fee</label>
                                                                <input type="number" required className="form-control" value={fee != undefined ? fee.consultingFee : 0} onChange={e => setFee({...fee, consultingFee: e.target.value})} />
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-sm-12">
                                                            <div className="form-group">
                                                                <label>Booking Fee</label>
                                                                <input type="number" required className="form-control" value={fee != undefined ? fee.bookingFee : 0} onChange={e => setFee({...fee, bookingFee: e.target.value})} />
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-sm-12">
                                                            <div className="form-group">
                                                                <label>Video Call Fee</label>
                                                                <input type="number" required className="form-control" value={fee != undefined ? fee.videoCallFee : 0} onChange={e => setFee({...fee, videoCallFee: e.target.value})} />
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-sm-12">
                                                            <div className="form-group">
                                                                <label>Discount %</label>
                                                                <input type="number" required className="form-control" max="100" value={fee != undefined ? fee.discount : 0} onChange={e => setFee({...fee, discount: e.target.value})} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="submit" className="btn btn-primary btn-block">Save Changes</button>
                                                </form>
                                            </div>
                                        </Modal.Body>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Profile;